"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cRRecipeGetRecipeById = void 0;
const GetRecipeById_1 = require("../../queries/GetRecipeById");
exports.cRRecipeGetRecipeById = (store, recipe) => {
    if (!recipe) {
        return;
    }
    store.writeQuery({
        query: GetRecipeById_1.getRecipeByIdQuery,
        data: {
            __typename: "Query",
            getRecipeById: recipe,
        },
        variables: { id: recipe.id },
    });
};
//# sourceMappingURL=createRecipeGetRecipeById.js.map